import {Button, Icon} from "~/components";
import {
	useCan
} from "~/hooks";

function GroupAction({item, onClickEdit, onClickDelete}) {

	const can = {
		edit: useCan('groupEdit'),
		delete: useCan('groupDelete'),
	};

	const buttonHandlers = {
		edit: () => {onClickEdit?.(item);},
		delete: () => {onClickDelete?.(item);},
	};

	const actionButtons = [
		can.edit && <Button key="edit" background blue leftIcon={Icon.edit} onClick={buttonHandlers.edit}></Button>,
		can.delete && <Button key="delete" background red leftIcon={Icon.delete} onClick={buttonHandlers.delete}></Button>,
	];

	return (
		<div className="table-action d-flex">
			{actionButtons}
		</div>
	)
}

export default GroupAction;